package cz.lhoracek.mapl.domain

import cz.lhoracek.mapl.data.model.Player
import cz.lhoracek.mapl.data.model.Round
import cz.lhoracek.mapl.data.model.Suit
import cz.lhoracek.mapl.data.model.GameType

/**
 * Calculates the score deltas for all players after a round.
 *
 * Returns a map of playerId -> delta (positive = gain, negative = loss).
 *
 * Rules:
 *   betValue = currentBet × round.multiplier
 *   If won:  actor gains  betValue × (playerCount - 1); each other loses betValue
 *   If lost: actor loses  betValue × (playerCount - 1); each other gains betValue
 */
object ScoreCalculator {

    fun calculateDeltas(
        round: Round,
        players: List<Player>,
        currentBet: Int,
    ): Map<String, Int> {
        val lepsiMultiplier = if (round.suit == Suit.LEPSI) 2 else 1
        val gameTypeMultiplier = round.gameType.multiplier
        val betValue = currentBet * round.multiplier * lepsiMultiplier * gameTypeMultiplier
        val otherCount = players.size - 1

        return players.associate { player ->
            val delta = if (player.id == round.actorId) {
                if (round.won) betValue * otherCount else -betValue * otherCount
            } else {
                if (round.won) -betValue else betValue
            }
            player.id to delta
        }
    }
}
